export const HOTMART_URL = "https://pay.hotmart.com/F103805522N";
export const HOTMART_URL_BASIC = "https://pay.hotmart.com/F103805522N?off=we6tz8o1";
